/* @flow */

import React from 'react';
import Relay from 'react-relay';
import { withRouter, withLocation } from 'depop/contextWrappers';
import Helmet from 'react-helmet';

import { compose } from 'recompose';

import NestedStatus from 'depop/components/NestedStatus';
import Container from 'depop/components/layout/Container';
import NotificationsList from 'depop/components/NotificationsList';

import { Modal } from 'depop/components/modal';

import NotificationsProvider from 'depop/components/NotificationsProvider';

import provideIdGenerator from 'depop/UniqueIdProvider';

import { injectIntl, defineMessages } from 'react-intl';

import { style, $ } from 'glamor';
import applyRootStyles from 'depop/utils/applyRootStyles';
import { currentUserFragment } from 'depop/getCurrentUser';

import DeeplinkConfig from 'depop/components/deeplinks/Deeplink';
import AppNavigation from './components/AppNavigation';
import DeeplinkBanner from 'depop/components/banners/DeeplinkBanner';

const NAME = 'Depop';
const IOS_ID = '518684914';
const ANDROID_ID = 'com.depop';
const TWITTER_ID = '380944344';
const FB_APP_ID = '127876583993492';

applyRootStyles();

const messages = defineMessages({
  description: {
    id: 'Application.defaultDescription',
    defaultMessage: 'Depop. Sell with a snap, buy with a tap.',
    description: 'Default description for meta tags, Twitter cards and other third party magic.',
  },
});

class Application extends React.Component {
  props: {
    children: Object,
    hideFooter: boolean,
    viewer: Object,
    intl: Object,
    location: Object,
    router: Object,
  };

  previousChildren: ?React.Element;

  static contextTypes = {
    resetEnvironment: React.PropTypes.func,
  };

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.location.key !== this.props.location.key &&
      nextProps.location.state &&
      nextProps.location.state.modal
    ) {
      this.previousChildren = this.props.children;
    }
  }

  handleModalClose = () => {
    const { location } = this.props;
    this.props.router.push(location.state.returnTo);
  };

  render() {
    const { children, viewer, location, intl, hideFooter } = this.props;
    const { pathname } = location;

    const showSearch = !pathname.startsWith('/search');

    const isModal =
      location.state && location.state.modal && this.previousChildren;

    return (
      <NotificationsProvider>
        <div
          {...style({
            margin: '0',
            padding: '0 0 30px 0',
          })}
          {...$('.focus-trap-wrapper', { background: 'green' })}
          {...$('.focus-trap', { background: 'purple' })}>
          <NestedStatus code={200} />
          <Helmet
            titleTemplate="%s - Depop"
            defaultTitle="Depop"
            htmlAttributes={{ lang: intl.locale }}
            meta={[
              { name: 'charset', content: 'utf-8' },
              {
                name: 'description',
                content: intl.formatMessage(messages.description),
              },
              {
                name: 'viewport',
                content: 'width=device-width, initial-scale=1',
              },
              { name: 'twitter:card', content: 'app' },
              { name: 'twitter:site', content: '@depop' },
              { name: 'twitter:creator:id', content: TWITTER_ID },
              {
                name: 'twitter:description',
                content: intl.formatMessage(messages.description),
              },
              { name: 'twitter:app:id:iphone', content: IOS_ID },
              { name: 'twitter:app:id:ipad', content: IOS_ID },
              { name: 'twitter:app:id:googleplay', content: ANDROID_ID },
              { name: 'twitter:app:name:iphone', content: NAME },
              { name: 'twitter:app:name:ipad', content: NAME },
              { name: 'twitter:app:name:googleplay', content: NAME },
              { name: 'twitter:app:url:iphone', content: 'depop://' },
              { name: 'twitter:app:url:ipad', content: 'depop://' },
              {
                name: 'twitter:app:url:googleplay',
                content: `https://play.google.com/store/apps/details?id=${ANDROID_ID}`,
              },
              { property: 'fb:app_id', content: FB_APP_ID },
            ]}
          />
          <DeeplinkConfig />
          <AppNavigation
            showSearch={showSearch}
            viewer={viewer}
            hideFooter={hideFooter}
          />
          <div {...style({ padding: '0 0 30px' })}>
            <Container>{isModal ? this.previousChildren : children}</Container>
          </div>
          <DeeplinkBanner />
          <NotificationsList />
          {isModal &&
            <Modal
              isOpened
              onClose={this.handleModalClose}
              previous={location.state.modalPrevious}
              next={location.state.modalNext}
              render={() => children}
            />}
        </div>
      </NotificationsProvider>
    );
  }
}

const enhance = compose(
  provideIdGenerator,
  withRouter,
  withLocation,
  injectIntl,
);

export default Relay.createContainer(enhance(Application), {
  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        ${currentUserFragment}
        ${AppNavigation.getFragment('viewer')}
      }
    `,
  },
});



// WEBPACK FOOTER //
// ../src/client/root/containers/Application.js